import avatar1 from "../assets/img/team/team-1.jpg";
import avatar2 from "../assets/img/team/team-2.jpg";
import avatar3 from "../assets/img/team/team-3.jpg";
import avatar4 from "../assets/img/team/team-4.jpg";
import avatar5 from "../assets/img/team/member-1.jpg";

const testimonialData = [
    {
        id: '01',
        name: 'Name S',
        position: 'Civil Engineer',
        des: 'From start to finish, BuildGo delivered exceptional service. They communicated well, met every deadline, and the quality of their work far exceeded our expectations.',
        avatar: avatar1,
    },
    {
        id: '02',
        name: 'Name D',
        position: 'Site Supervisor',
        des: 'Working with BuildGo was an absolute breeze. They handled everything efficiently, professionally, and the final product was outstanding. I recommend their services.',
        avatar: avatar2,
    },
    {
        id: '03',
        name: 'Name T',
        position: 'Construction Laborer',
        des: 'BuildGo transformed our office space beyond what we imagined. Their team was responsive, thorough, and the project was completed on time without any issues!',
        avatar: avatar3,
    },
    {
        id: '04',
        name: 'Name B',
        position: 'Architect',
        des: 'The BuildGo team exceeded my expectations with their innovative designs and timely execution. They truly brought our vision to life with precision and creativity.',
        avatar: avatar4,
    },
    {
        id: '05',
        name: 'Name R',
        position: 'Project Manager',
        des: 'The BuildGo team impressed me with their attention to detail and ability to deliver results. Their commitment to excellence is unmatched, and I couldn’t be happier with the outcome.',
        avatar: avatar5,
    },
];

export default testimonialData;